import { NoFilterResultsBanner } from '../NoFilterResultsBanner';
import { NoSearchResultsBanner } from '../NoSearchResultsBanner';

export const EMPTY_STATE_BANNER_TYPES = {
  search: 'search',
  filter: 'filter',
} as const;

type EmptyStateBannerTypes =
  (typeof EMPTY_STATE_BANNER_TYPES)[keyof typeof EMPTY_STATE_BANNER_TYPES];

interface EmptyStateBannerWrapperProps {
  type?: EmptyStateBannerTypes;
  isMobileView?: boolean;
}

export const EmptyStateBannerWrapper = ({
  type,
  isMobileView,
}: EmptyStateBannerWrapperProps) => {
  if (type === EMPTY_STATE_BANNER_TYPES.filter) {
    return <NoFilterResultsBanner isMobileView={isMobileView} />;
  }

  if (type === EMPTY_STATE_BANNER_TYPES.search) {
    return <NoSearchResultsBanner isMobileView={isMobileView} />;
  }

  return null;
};
